import React, { useState } from 'react'
import ReactJson from 'react-json-view'
import { useFormContext, Controller } from 'react-hook-form'
import ContentCopyIcon from '@mui/icons-material/ContentCopy'
import { useTranslate } from 'react-admin'
export const JsonInput = ({ source, defaultValue, width = '700', maxWidth, onChange }) => {
  const translate = useTranslate()
  const { control } = useFormContext()
  const [textAreaValue, setTextAreaValue] = useState('')
  const [jsonError, setJsonError] = useState(false)
  const [copied, setCopied] = useState(false)
  const handleJsonChange = (edit, field) => {
    field.onChange(edit.updated_src)
    onChange && onChange(edit.updated_src)
  }

  const handleTextAreaChange = (event, field) => {
    setTextAreaValue(event.target.value)

    try {
      const jsonValue = JSON.parse(event.target.value)
      setJsonError(false)
      field.onChange(jsonValue)
      onChange && onChange(jsonValue)
    } catch (error) {
      setJsonError(true)
    }
  }

  const copyToClipboard = (e, value) => {
    navigator.clipboard.writeText(JSON.stringify(value) || {})
    setCopied(true)
    setTimeout(() => setCopied(false), 300)
    e.stopPropagation()
  }

  const shouldShowButton = (value) => {
    if (value && typeof value === 'object' && Object.keys(value).length === 0) {
      return false
    }
    return !!value
  }

  return (
    <div style={{ width: width, maxWidth: maxWidth }}>
      <Controller
        control={control}
        name={source}
        defaultValue={defaultValue}
        render={({ field }) => (
          <>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <textarea
                value={textAreaValue}
                placeholder={translate('ra.message.enter_json')}
                onChange={(e) => handleTextAreaChange(e, field)}
                style={{ width: '100%', height: '100px', flexGrow: 1 }}
              />
              {shouldShowButton(field.value) ? (
                <button
                  onClick={(e) => copyToClipboard(e, field.value)}
                  style={{
                    background: copied ? '#4caf50' : 'none',
                    borderRadius: '4px',
                    cursor: 'pointer',
                    border: 'none',
                    padding: '5px',
                    transition: 'background 0.1s',
                  }}
                  type='button'
                  title={translate('ra.message.copy_to_clipboard')}
                >
                  <ContentCopyIcon fontSize='small' style={{ color: copied ? 'white' : 'black' }} />
                </button>
              ) : null}
            </div>
            {jsonError && <p style={{ color: 'red' }}>{translate('ra.message.invalid_json')}</p>}
            <div
              style={{
                maxHeight: '400px',
                overflowY: 'scroll',
                border: '1px solid #ccc',
                padding: '10px',
                marginTop: '10px',
                scrollbarWidth: 'thin',
                scrollbarColor: '#888 #f5f5f5',
              }}
            >
              <ReactJson
                src={field.value || {}}
                onEdit={(edit) => handleJsonChange(edit, field)}
                onDelete={(edit) => handleJsonChange(edit, field)}
                onAdd={(edit) => handleJsonChange(edit, field)}
                style={{ backgroundColor: 'white' }}
                name={null}
                iconStyle='triangle'
                collapsed={false}
                enableClipboard={false}
                displayDataTypes={false}
              />
            </div>
          </>
        )}
      />
    </div>
  )
}
